// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Content = styled.div`
  max-width: ${props => props.maxWidth};
  display: flex;
  padding: 0 18px 32px;
  margin: 0 auto;
`;

const Wrapper = styled.div`
  width: 100%;
  background-color: #fff;
  display: none;
  position: absolute;
  right: 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary.magenta};
  z-index: 1000;
  box-sizing: border-box;

  ${props => props.small &&
    css`
      width: inherit;
      border-bottom-left-radius: 11px;
      border-bottom-right-radius: 11px;
      border: none;
      max-width: 1267px;
      right: 0;

      & > ${Content} {
        width: inherit;
        display: block;
        min-width: 227px;
      }
    `}
`;

const Column = styled.div`
  flex: 1;
  margin: 0 14px;
`;

const Category = styled.div``;

const CategoryLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.default.fontFamily}, Helvetica, Arial, Sans-Serif;
  font-weight: bold;
  text-decoration: none;
  color: inherit;
  margin-top: 32px;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  margin-top: 16px;
`;

const SubcategoryLink = styled.a`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

const DropdownMenu = ({
  navigationData, small, maxWidth, ...rest
}) => {
  const renderSubcategories = data => (data?.length ? (
    <List>
      {data.map((subcategory, i) => (
        <ListItem key={`${i}: ${subcategory.label}`}>
          <SubcategoryLink href={subcategory.link}>
            {subcategory.label}
          </SubcategoryLink>
        </ListItem>
      ))}
    </List>
  ) : null);

  const renderCategories = data => (data?.length ? (
    data.map((category, i) => (
      <Category key={`${i}: ${category.label}`}>
        <CategoryLink href={category.link}>{category.label}</CategoryLink>
        {renderSubcategories(category.nav)}
      </Category>
    ))
  ) : (
    <Category>
      <CategoryLink href={data.link}>{data.label}</CategoryLink>
    </Category>
  ));

  return (
    <Wrapper
      // @ts-ignore
      small={small}
      {...rest}
    >
      
      <Content
        // @ts-ignore
        maxWidth={maxWidth}
      >
        {navigationData &&
          navigationData.map((column, i) => (
            <Column key={i}>{renderCategories(column)}</Column>
          ))}
      </Content>
    </Wrapper>
  );
};

DropdownMenu.propTypes = {
  navigationData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object])
  ),
  small: PropTypes.bool,
  maxWidth: PropTypes.string
};

DropdownMenu.defaultProps = {
  navigationData: null,
  small: false,
  maxWidth: '1267px'
};

export default DropdownMenu;
